import { render } from "./SexVerticalBarChart.vue?vue&type=template&id=e00a8464"
import script from "./SexVerticalBarChart.vue?vue&type=script&lang=js"
export * from "./SexVerticalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__